import { GET_ERROR_LOG, SET_ERROR_LOG } from "./ErrorLogType"


const getErrorLogs = (value: any) => {
    
    return {
      type: GET_ERROR_LOG,
      value
    }
}
const setErrorLogs = (value: any) => {
    
    return {
      type: SET_ERROR_LOG,
      value
    }
}


export {
    getErrorLogs,
    setErrorLogs    
    
}
